import shared from "emun.products/configurator/product-configurator.config.es6";

export default Object.assign(shared, {
  valuesQuery: {
    ...shared.valuesQuery,
    view: "list",
  },
  disableValuePrompt: false,
});
